import { Directive, HostListener } from '@angular/core';
import { CommonDataService } from '../services/common-data.service';

@Directive({
  selector: '[appHostListenerClick]'
})
export class HostListenerClickDirective {
  constructor(private commonDataService: CommonDataService) { }

  @HostListener('click', ['$event']) click(event: any) {
    var is_right_overlay_exists = event?.target?.classList?.contains('right-Overlay');
    var id = event?.target?.id;
    if (is_right_overlay_exists) {
      if (event?.target?.dataset?.parent != undefined && event?.target?.id != event?.target?.dataset?.parent) {
        this.commonDataService.NavigatingFromComponent.next(event?.target?.dataset?.parent);
        this.commonDataService.childComponent.next(true);
      }
      if (id == "glossary-term-usage" || id == "glossary-term-topic") {
        this.commonDataService.glossaryTermData.next(event?.target?.topicData);
        if (id == "glossary-term-topic") {
          this.commonDataService.glossaryTermTopicGlossaryTitle.next(event?.target?.glossaryTitle);
        }
      }

      if (id == "generalFeedback") {
        this.redirectRightOverlay("General Feedback");

      } else {
        this.commonDataService.TargetDivId.next("");

        this.redirectRightOverlay(id);
      }
      if (id == "pcsfaq-limitations") {
        this.commonDataService.TargetDivId.next("limitations");
        this.redirectRightOverlay("pcsfaq");

      }
    }
    const path: any = event.composedPath() as Array<any>;
    const matFormField = path.find(p => p.tagName && p.tagName.toLowerCase() === 'mat-form-field');
    var cdk_pane = Array.from(document.getElementsByClassName('cdk-overlay-pane') as HTMLCollectionOf<HTMLElement>)

    if (matFormField) {
      cdk_pane.forEach(x => {
        var clientWidth = matFormField.clientWidth;
        var matPosition = matFormField.getBoundingClientRect();
        // x.style.top = offsetTop + 35 + 'px';
        x.style.top = matPosition.top + 35 + 'px';
        x.style.minWidth = clientWidth + 'px';
        x.style.left = matPosition.left + 'px';
        x.style.transform = 'unset';
      })
    }
  }
  redirectRightOverlay(id) {
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next(id);
    if (id == "glossary-term-topic" || id == "General Feedback") {
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    }
  }
}
